/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import WeatherPresenter from "./WeatherPresenter";
import DTOWeather from "./DTOWeather";

function WeatherController() {
  const [weatherData, setWeatherData] = useState({
    name: "",
    card_title: "",
    designation: "",
    pic: "",
    awards: "",
  });

  const handleOnData = (data: any): any => {
    setWeatherData({
      name: data?.emp_name,
      card_title: "",
      designation: data?.emp_designation,
      pic: data?.profile_pic,
      awards: data?.awards,
    });
  };
  return (
    <>
      <DTOWeather onData={handleOnData} />
      <WeatherPresenter weather={weatherData} />
    </>
  );
}

export default WeatherController;
